import { INITIALVALUES } from "shared/components-pages/formulario-prestamos/form-section/util/form.util";
import { ILoan } from "api/messages.request";
import {
  queryFormatter,
  queryParserUrl,
} from "shared/models/functions/query-string-helper";

type ValuesType = typeof INITIALVALUES;

export function loanValuesAdapter(values: ValuesType) {
  const data: ILoan = {
    full_name: values.full_name,
    nationality: values.nationality,
    cedula: values.identification,
    phone: values.phone,
    cell_phone: values.cellPhone,
    email: values.email,
    current_country_residence: values.residence,
    initial_payment_value: values.initialPayment,
    amount_finance: values.amountFinance,
    comment: values.comment,
    realestate_id: values.realestateId,
    agent: values.agentCode,
    agency_id: values.agencyCode,
    birthdate: values.birthDate,
    "g-recaptcha-response": values.captcha,
  };
  if (data.agent == "" || !data.agent) {
    delete data.agent;
  }

  if (data.agency_id == "" || !data.agency_id) {
    delete data.agency_id;
  }

  return data;
}

export function loanUrlValuesAdapter(values: any) {
  const data: any = {
    // bankRate: values.bankRate,
    // loanDuration: values.loanDuration
    // propertyValue: values.propertyValue,
    initialPayment: values.initialPayment,
    amountFinance: values.loanAmount,
    realestateId: values.realestateId,
    currency: values.currency,
  };

  if (values.referer) {
    data.referer = values.referer;
  } else if (values.areferer) {
    data.areferer = values.areferer;
  }

  return queryFormatter(data);
}

export function loanFormValuesAdapter() {
  const { query } = queryParserUrl(location.href);

  const data = {
    amountFinance: query.amountFinance || "",
    realestateId: query.realestateId || "",
    initialPayment: query.initialPayment || "",
    agentCode: query.referer || "",
    agencyCode: query.areferer || "",
  };

  return data;
}
